"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const global_1 = require("../global");
exports.ZONE_METRICS = [
    {
        id: global_1.ZoneMetricId.TotalRevenueAfterClick,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.AverageRevenueAfterClick,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.AvgConversionAfterClick,
        category: global_1.ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.AvgConversionAfterHover,
        category: global_1.ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop],
    },
    {
        id: global_1.ZoneMetricId.AvgTransactionAfterClick,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.AvgTransactionAfterHover,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop],
    },
    {
        id: global_1.ZoneMetricId.ClickRate,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.ClickDistribution,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.TimeBeforeFirstClick,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csSeconds',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.HoverRate,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop],
    },
    {
        id: global_1.ZoneMetricId.EngagementRate,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [global_1.Device.Desktop],
    },
    {
        id: global_1.ZoneMetricId.Hesitation,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csSeconds',
        devices: [global_1.Device.All, global_1.Device.Desktop],
    },
    {
        id: global_1.ZoneMetricId.HoverTime,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csSeconds',
        devices: [global_1.Device.All, global_1.Device.Desktop],
    },
    {
        id: global_1.ZoneMetricId.ClickRepetition,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csNumber',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.ExposureRate,
        category: global_1.ZoneMetricCategory.Heatmap,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.ExposureTime,
        category: global_1.ZoneMetricCategory.Heatmap,
        format: 'csSeconds',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.AttractivenessRate,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.TotalClicks,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csInteger',
        devices: [global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet],
    },
    {
        id: global_1.ZoneMetricId.TotalRevenueAfterTap,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.AverageRevenueAfterTap,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.TransactionAfterTap,
        category: global_1.ZoneMetricCategory.ROI,
        format: 'csRate',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.ConversionAfterTap,
        category: global_1.ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.ConversionRatePerSwipe,
        category: global_1.ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.TapRate,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.TapRecurrence,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csNumber',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.TapCount,
        format: 'csInteger',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.TapDistribution,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.TimeBeforeFirstTap,
        category: global_1.ZoneMetricCategory.Attractiveness,
        format: 'csSeconds',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.SwipeRate,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
    {
        id: global_1.ZoneMetricId.SwipeRecurrence,
        category: global_1.ZoneMetricCategory.Interaction,
        format: 'csNumber',
        devices: [global_1.Device.MobileSdk, global_1.Device.TabletSdk],
    },
];
class MetricsListBuilder {
    constructor() {
        this.filterByProjectType = (isSDK) => this.filterMetric(metric => isSDK
            ? lodash_1.intersection([global_1.Device.MobileSdk, global_1.Device.TabletSdk], metric.devices).length > 0
            : lodash_1.intersection([global_1.Device.All, global_1.Device.Desktop, global_1.Device.Mobile, global_1.Device.Tablet], metric.devices).length > 0);
        this.filterById = (id) => this.filterMetric(metric => metric.id === id);
        this.filterByDevice = (devices) => this.filterMetric(metric => lodash_1.intersection(devices, metric.devices).length > 0);
        this.applyCustomFilterFn = (filterFn) => this.filterMetric(filterFn);
    }
    filterMetric(precondition) {
        return (metrics) => metrics.filter(precondition);
    }
    getFilterFn(filterType) {
        switch (filterType) {
            case 'isSDK':
                return this.filterByProjectType;
            case 'metricId':
                return this.filterById;
            case 'devices':
                return this.filterByDevice;
            case 'customFilter':
                return this.applyCustomFilterFn;
            default:
                return () => metrics => metrics;
        }
    }
    composeFilters(filters) {
        const filtersFn = Object.entries(filters).map(([type, value]) => this.getFilterFn(type)(value));
        return filtersFn.reduce((fn, filterFn) => {
            return (metrics) => fn(filterFn(metrics));
        }, metrics => metrics);
    }
    getMetrics(filters = {}) {
        const filterFn = this.composeFilters(filters);
        return filterFn(exports.ZONE_METRICS);
    }
    getCategorizedMetrics(filters = {}) {
        const metricsWithCategory = this.getMetrics(filters).filter(metric => !!metric.category);
        return lodash_1.groupBy(metricsWithCategory, 'category');
    }
}
exports.MetricsListBuilder = MetricsListBuilder;
//# sourceMappingURL=zone-metrics.js.map